'use client'
import { Button, ButtonProps } from '@/components/ui/button'
import { useFormStatus } from 'react-dom'

export function LoadingButton({ isDisabled, ...rest }: ButtonProps) {
  const { pending } = useFormStatus()

  return <Button isLoading={pending} isDisabled={isDisabled} {...rest} />
}
